// extracted by mini-css-extract-plugin
module.exports = {"panel":"Collapse_panel__iVwD7","heading":"Collapse_heading__XT2Ps","title":"Collapse_title__qG_UK"};